import { Component, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { EpButtonStyle, EpButtonSize, EpEventService  } from '@epicor/kinetic';
import { EpbtFaNewQuickOrderCustomerDetailsComponent } from '../epbt-fa-new-quick-order-customer-details/epbt-fa-new-quick-order-customer-details.component';
import { FormControl } from '@angular/forms';
import { CustomEvents } from 'ep-bt-controls';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'epbt-fa-new-quick-order-details',
  templateUrl: './epbt-fa-new-quick-order-details.component.html',
  styleUrls: ['./epbt-fa-new-quick-order-details.component.scss']
})
export class EpbtFaNewQuickOrderDetailsComponent implements OnInit {
  EpButtonStyle = EpButtonStyle;
  @ViewChild(EpbtFaNewQuickOrderCustomerDetailsComponent, {static: false}) epbtFaNewQuickOrderCustomerDetailsComponent: EpbtFaNewQuickOrderCustomerDetailsComponent;

  @Output() selectContactSearch = new EventEmitter<any>();
  @Output() selectAddressSearch = new EventEmitter<any>();

  selected = new FormControl(0);

  constructor(public epEvent: EpEventService) {
    this.epEvent.onEvents([CustomEvents.NewQuickorderProductTabSelect]).subscribe(event => {
      this.changeTab();
    });
   }

  ngOnInit() {
  }

  public onTabSelect(e) {
    // this.index = e.index;
  }


  changeTab() {
    this.selected.setValue(this.selected.value + 1);
 }



  onCustomerChange() {
    this.epbtFaNewQuickOrderCustomerDetailsComponent.bindValuesToForm();
  }

  storeCustomerDetails() {
    this.epbtFaNewQuickOrderCustomerDetailsComponent.storeData();
  }

  onSearchContactClick(data: any) {
    this.selectContactSearch.emit(data);
  }

  onSearchAddressClick(data: any) {
    this.selectAddressSearch.emit(data);
  }
}
